export default __webpack_public_path__ + "static/media/ThePoopManThinksAbout.c11b9bef.svg";